// File Metadata:
// Filename: User.js
// Version: 1.00
// Created: 2022-09-29 09:53:53
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from 'react-router-dom'
import { useGetUsersQuery } from '../api/usersApiSlice'
import { memo } from 'react'

const User = ({ userId }) => {
	const { user } = useGetUsersQuery('usersList', {
		selectFromResult: ({ data }) => ({
			user: data?.entities[userId]
		})
	})

	const navigate = useNavigate()

	if (user) {
		const handleEdit = () => navigate(`/dash/users/${userId}`)

		const userRolesString = user.roles.toString().replaceAll(',', ', ')

		const cellStatus = user.active ? '' : 'table__cell--inactive'

		return (
			<tr className='table__row user'>
				<td className={`table__cell ${cellStatus}`}>{user.username}</td>
				<td className={`table__cell ${cellStatus}`}>{userRolesString}</td>
				<td className={`table__cell ${cellStatus}`}>
					<button className='icon-button table__button' onClick={handleEdit}>
						<FontAwesomeIcon icon={faPenToSquare} />
					</button>
				</td>
			</tr>
		)
	} else return null
}
const memoizedUser = memo(User)
export default memoizedUser
